class UnitDeploymentConfig {
  constructor(unitId, deploymentConfig) {
    this.unitId = unitId;
    this.deploymentConfig = deploymentConfig;
  }
}

export default UnitDeploymentConfig;